import { render, staticRenderFns } from "./ug_list.vue?vue&type=template&id=50ed18be&scoped=true&"
import script from "./ug_list.vue?vue&type=script&lang=js&"
export * from "./ug_list.vue?vue&type=script&lang=js&"
import style0 from "./ug_list.vue?vue&type=style&index=0&id=50ed18be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ed18be",
  null
  
)

export default component.exports